import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActSceneNavigation = ({ 
  acts, 
  currentAct, 
  currentScene, 
  onNavigate,
  readingProgress 
}) => {
  const currentActData = acts?.find(act => act?.actNumber === currentAct);
  const scenes = currentActData?.scenes || [];

  const handlePrevious = () => {
    const currentSceneIndex = scenes?.findIndex(s => s?.sceneNumber === currentScene);
    if (currentSceneIndex > 0) {
      onNavigate(currentAct, scenes?.[currentSceneIndex - 1]?.sceneNumber);
    } else if (currentAct > 1) {
      const prevAct = acts?.find(a => a?.actNumber === currentAct - 1);
      const lastScene = prevAct?.scenes?.[prevAct?.scenes?.length - 1];
      onNavigate(currentAct - 1, lastScene?.sceneNumber);
    }
  };

  const handleNext = () => {
    const currentSceneIndex = scenes?.findIndex(s => s?.sceneNumber === currentScene);
    if (currentSceneIndex < scenes?.length - 1) {
      onNavigate(currentAct, scenes?.[currentSceneIndex + 1]?.sceneNumber);
    } else if (currentAct < acts?.length) {
      onNavigate(currentAct + 1, 1);
    }
  };

  const canGoPrevious = currentAct > 1 || currentScene > 1;
  const canGoNext = currentAct < acts?.length || currentScene < scenes?.length;

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-screen-2xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between gap-4">
          <Button
            variant="outline"
            size="sm"
            iconName="ChevronLeft"
            iconPosition="left"
            onClick={handlePrevious}
            disabled={!canGoPrevious}
          >
            Previous Scene
          </Button>

          <div className="flex items-center gap-2 overflow-x-auto">
            {acts?.map((act) => (
              <div key={act?.actNumber} className="flex items-center gap-1">
                <button
                  className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-150 ${
                    currentAct === act?.actNumber
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                  onClick={() => onNavigate(act?.actNumber, 1)}
                >
                  Act {act?.actNumber}
                </button>
                {act?.actNumber < acts?.length && (
                  <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
                )}
              </div>
            ))}
          </div>

          <Button
            variant="outline"
            size="sm"
            iconName="ChevronRight"
            iconPosition="right"
            onClick={handleNext}
            disabled={!canGoNext}
          >
            Next Scene
          </Button>
        </div>

        <div className="mt-3">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs text-muted-foreground">Reading Progress</span>
            <span className="text-xs font-medium text-foreground">{readingProgress}%</span>
          </div>
          <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-primary to-secondary transition-all duration-300"
              style={{ width: `${readingProgress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActSceneNavigation;